// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"560":"80bb51c1","852":"80bb51c1"}[chunkId] + ".chunk.css";
};